<main class="main">
    <div class="page-header text-center" style="background-image: url(assets/images/aboutus-new.jpg)">
        <div class="container">
            <h1 class="page-title">Buy Edibles Online Rye</h1>
        </div>
    </div>


    <div class="container">
        <div class="DataPart">
            <div class="row align-items-center mt-5">
                <div class="col-8">
                    <div class="heading-main">
                        <h2 class="title-lg" tabindex="0">Edibles</h2>
                        <p class="headeig_home_sub" tabindex="0" role="text">Gummies, Chocolates, and More. Yum!</p>
                    </div>
                </div>
                <div class="col-4">
                    <div class="view-more-link cursor">
                        <a [ngStyle]="getColor('text')" tabindex="0" [routerLink]="['/shop/Edibles_edibles']">View
                            More</a>
                    </div>
                </div>
            </div>
            <div>
                <app-product-listing [payLoad]="payload"></app-product-listing>
            </div>
        </div>
    </div>

    <div class="contactPage">
        <div class="container">
            <div class="DataPart">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <figure>
                            <img src="assets/images/Edibles-products.png" alt="Buy Cannabis Edibles Rye NY">
                        </figure>
                    </div>
                    <div class="col-md-6">
                        <h2>Buy Edibles Online Rye, NY</h2>
                        <h3>Discover Highlife Health: New Rochelle’s Premier Cannabis Retailer</h3>
                        <p>Looking to buy cannabis edibles in Rye NY without the hassle? Highlife Health is your trusted
                            source for premium cannabis edibles near Rye, NY, which is conveniently located in New
                            Rochelle, provides a large selection of THC edibles, such as gummies, chocolates and
                            tinctures, along with unrivaled customer service and the option to order online for in-store
                            pickup. From browsing to buying, Highlife Health guarantees an excellent experience, whether
                            you're searching for calming tinctures or stocking up on sleep-supporting gummies.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="contactPage bgimg" style="background: url(assets/images/weedbg.jpg);">
        <div class="container">
            <div class="DataPart">
                <h2 class="mb-4 text-center">Why Rye Residents Choose Highlife Health</h2>
                <div class="row">
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four">
                            <h4>Proximity & Convenience</h4>
                            <p>Highlife Health is conveniently situated along major routes, making it easy to reach from
                                Rye at 17 Huguenot Street, New Rochelle, NY.</p>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four">
                            <h4>Effortless Online Ordering</h4>
                            <p>Shop their wide selection of edibles online, place a secure order, and pick it up
                                whenever it's convenient for you.</p>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four">
                            <h4>A Wide Variety of Edibles</h4>
                            <p>Highlife Health has over 149 edible products, including tinctures, live-resin gummies,
                                fast-acting caramels, and more. Items on their menu include:</p>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four">
                            <ul>
                                <li><i class="icon-check"></i>LIT MOODZ – Elevate your mood with LIT MOODZ’s bold
                                    edibles—flavors that pop and effects that
                                    keep pace with your day.</li>
                                <li><i class="icon-check"></i>MFNY – Crafted from New York’s finest, MFNY delivers
                                    premium live-resin gummies that set a high
                                    standard.</li>
                                <li><i class="icon-check"></i>MOUNTAIN HIGH – Reach new peaks with MOUNTAIN HIGH’s
                                    expertly blended treats, where flavor
                                    meets quality every time.</li>
                                <li><i class="icon-check"></i>NICE POP – Light, bright and just what you need—NICE POP
                                    brings fun and easy-going edibles for
                                    relaxed occasions.</li>
                                <!-- <li><i class="icon-check"></i>Heavy Hitters, Eaton Botanicals, Flav, Cannabals, and more.</li> -->
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="catName">
        <div class="container">
            <div class="catList">
                <ul>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Flower_flower')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/flower-c.png"
                            alt="Flower"><span>Flower</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Vapes_vaporizers')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Vapes-c.png"
                            alt="Vapes"><span>Vapes</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Edibles_edibles')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/edibles-c.png"
                            alt="Edibles"><span>Edibles</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Pre roll_pre-rolls')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Pre-roll-c.png"
                            alt="Pre Rolls"><span>Pre Rolls</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Concentrates_concentrates')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Concentrates-c.png"
                            alt="Concentrates"><span>Concentrates</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Tinctures_tinctures')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/tincture-c.png"
                            alt="Tinctures"><span>Tinctures</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Topical_topical')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/topical-c.png"
                            alt="Topical"><span>Topical</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Accessories_accessories')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Accessories-c.png"
                            alt="Accessories"><span>Accessories</span></li>
                </ul>
            </div>
        </div>
    </div>


    <div class="contactPage pt-3">
        <div class="container">
            <div class="DataPart">
                <div class="row ">
                    <div class="col-md-4">
                        <h2>Buy THC Edibles Rye NY - How It Works</h2>
                        <h3>Visit the Menu of Highlife Health</h3>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="boxes-four">
                                    <h4>To explore the full range of THC and cannabis edibles.</h4>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four">
                                    <h4>Enjoy Responsibly</h4>
                                    <p>Edibles offer long-lasting, controlled experiences. Go slowly and start low.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four">
                                    <h4>Choose Your Products</h4>
                                    <p>Choose the appropriate strength and effects for your needs by sorting by
                                        category, such as chocolates, tinctures, or gummies.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four">
                                    <h4>Order Online, Pick Up In-Store</h4>
                                    <p>Add items to your cart, place your order securely, and stop by the store for
                                        pickup. No wait, no hassle.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="contactPage pt-0">
        <div class="container">
            <div class="DataPart">
                <h2 class="mb-1 mt-0 text-center">Popular Cannabis Edibles Available</h2>
                <h3 class="text-center mb-3">If you're searching to buy cannabis edibles in Rye NY, here are just a few
                    favorites from Highlife Health’s inventory:</h3>
                <div class="row align-items-stretch">
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew m-0">Ayrloom Orchard Sunrise Gummies - Fruity, uplifting daytime edible
                            </h4>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew m-0">Eaton Botanicals Dark Cherry Infused Gummies - For a restful night’s
                                sleep</h4>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew m-0">Heavy Hitters Midnight Cherry Infused Gummies - Providing full-body
                                relaxation and mental calmness</h4>
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew m-0">Cannabals Cones - Milk Chocolate - Crunchy, creamy, and
                                oh-so-dreamy.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="faqSection pt-0">
        <div class="container">
            <h2>Buy Cannabis Edibles Rye NY – FAQ</h2>
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="faqsPart">
                        <h4>Can I buy THC edibles online from Rye NY?</h4>
                        <p>Yes. You can place an online order with Highlife Health and pick it up at their New Rochelle
                            dispensary.</p>
                    </div>
                    <div class="faqsPart">
                        <h4>Are cannabis edibles legal in Rye NY?</h4>
                        <p>Yes. Adults 21+ can legally purchase cannabis edibles in New York, including in Rye.</p>
                    </div>
                    <div class="faqsPart">
                        <h4>What’s the max THC allowed in NY edibles?</h4>
                        <p>The majority of products have a clear dosage for safe consumption and contain up to 100 mg of
                            THC per package.</p>
                    </div>
                </div>
            </div>
            <h2 class="mt-4">Ready to Buy THC Edibles in Rye NY?</h2>
            <p class="ptagd">Whether you’re seeking relaxation, pain relief, or sleep support, Highlife Health has the
                perfect edible for you. Skip the uncertainty browse the menu, order online, and enjoy premium cannabis
                edibles backed by real expertise.</p>




            <div class="abtclas pt-3">
                <h3><b>Fast Cannabis & Vape Delivery in These Areas</b></h3>
                <p>We proudly deliver high-quality cannabis, vapes, edibles, and pre-rolls across multiple NY locations.
                    Check out
                    our
                    nearby service areas below.</p>

                <div class="weed-location-grid">

                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_Larchmont_NY">
                            <h4>Larchmont NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Disposable_Vapes_Larchmont_NY">
                            <h4>Larchmont NY</h4>
                            <p>Vape Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Buy_Weed_Online_in_Rye">
                            <h4>Rye NY</h4>
                            <p>Weed Delivery</p>
                        </a>

                    </div>


                    <div class="location-box">
                        <a routerLink="/Buy_Edibles_Online_Rye">
                            <h4>Rye NY</h4>
                            <p>Edibles Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Buy_Pre_Rolls_Online_in_Rye_NY">
                            <h4>Rye NY</h4>
                            <p>Pre Rolls Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>

                    <div class="location-box">
                        <a routerLink="/Vape_Pen_Cartridges_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Vape Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Weed_Delivery_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Weed Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Weed_Delivery_Bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Weed Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Vape_Pen_Cartridges_Bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Vape Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/THC_Drinks_in_Bronx">
                            <h4>Bronx NY</h4>
                            <p>THC Drinks</p>
                        </a>
                    </div>
                </div>

            </div>
        </div>


    </div>



</main>